import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BrandDropdown } from './BrandDropdown';
import { ProfileDropdown } from './ProfileDropdown';
import { ShieldIcon } from 'lucide-react';
interface HeaderProps {
  brands: Array<{
    id: number;
    name: string;
  }>;
  selectedBrand: {
    id: number;
    name: string;
  } | null;
  setSelectedBrand: (brand: {
    id: number;
    name: string;
  } | null) => void;
}
export const Header: React.FC<HeaderProps> = ({
  brands,
  selectedBrand,
  setSelectedBrand
}) => {
  return <header className="bg-white shadow-sm" data-id="element-152">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-153">
        <Link to="/" className="flex items-center space-x-2" data-id="element-154">
          <ShieldIcon className="h-8 w-8 text-blue-600" data-id="element-155" />
          <span className="text-xl font-bold text-gray-900" data-id="element-156">BrandFirewall</span>
        </Link>
        <div className="flex items-center space-x-4" data-id="element-157">
          <BrandDropdown brands={brands} selectedBrand={selectedBrand} setSelectedBrand={setSelectedBrand} data-id="element-158" />
          <ProfileDropdown data-id="element-159" />
        </div>
      </div>
    </header>;
};